import type { ReactNode } from 'react';

/** Çek / kredi çekmecelerinin ortak iskeleti ve küçük parçaları (Kasa çekmeceleriyle aynı görünüm). */
export function Cekmece({ ust, baslik, kapat, mesgul, children, genis }: {
  ust: string; baslik: string; kapat: () => void; mesgul?: boolean; children: ReactNode; genis?: boolean;
}) {
  return (
    <div className="ccd-drawer-arka" onClick={() => !mesgul && kapat()} role="presentation">
      <aside className={`ccd-drawer${genis ? ' ccd-kasa-cekmece-genis' : ''}`} onClick={(e) => e.stopPropagation()} role="dialog" aria-modal="true" aria-label={baslik}>
        <div className="ccd-stack">
          <div className="ccd-row-between">
            <div><div className="ccd-eyebrow">{ust}</div><h2 className="ccd-heading">{baslik}</h2></div>
            <button type="button" className="ccd-btn ccd-btn-ghost ccd-btn-sm" onClick={kapat} disabled={mesgul}>Kapat</button>
          </div>
          {children}
        </div>
      </aside>
    </div>
  );
}

export const Hata = ({ m }: { m: string | null }) => (m
  ? <div className="ccd-banner ccd-banner-danger" role="alert"><span className="ccd-banner-icon" aria-hidden="true">!</span><span>{m}</span></div> : null);
export const Bilgi = ({ m }: { m: ReactNode | null }) => (m
  ? <div className="ccd-banner" role="status"><span className="ccd-banner-icon" aria-hidden="true">✓</span><span>{m}</span></div> : null);
export const Uyari = ({ m }: { m: ReactNode | null }) => (m
  ? <div className="ccd-banner ccd-banner-warning" role="status"><span className="ccd-banner-icon" aria-hidden="true">!</span><span>{m}</span></div> : null);

export function Alan({ etiket, htmlFor, zorunlu, ipucu, children, not }: {
  etiket: string; htmlFor?: string; zorunlu?: boolean; ipucu?: ReactNode; children: ReactNode; not?: ReactNode;
}) {
  return (
    <div className="ccd-field">
      <label className="ccd-field-label" htmlFor={htmlFor}>{etiket}{zorunlu && <span className="ccd-required"> *</span>} {ipucu}</label>
      {children}
      {not && <div className="ccd-meta">{not}</div>}
    </div>
  );
}

/** Not satırı: "ⓘ …" — nakit kuralı gibi ekranda açıkça söylenmesi gereken şeyler. */
export const NotSatiri = ({ children }: { children: ReactNode }) => (
  <div className="ccd-kasa-bilgi" role="note"><span aria-hidden="true">ⓘ</span><span>{children}</span></div>
);
